import { getStyleValue } from "@/utils/theme"

export const getBackgroundBoolean = (styleString:string)=>{
    const backgroundOn = getStyleValue({styleString,field:"backgroundState"})
    if(backgroundOn==="on"){
        return true
    }
    return false
}